var map = {
	"./Mobil.svg": 229869,
	"./actions/alberta-add-to-outlook.svg": 771509,
	"./actions/alberta-add.svg": 243528,
	"./actions/alberta-box.svg": 289805,
	"./actions/alberta-cancel.svg": 107762,
	"./actions/alberta-close-button.svg": 2656,
	"./actions/alberta-cloud-upload.svg": 871096,
	"./actions/alberta-copy-url.svg": 18310,
	"./actions/alberta-copy.svg": 69248,
	"./actions/alberta-delete.svg": 189210,
	"./actions/alberta-download-2.svg": 319246,
	"./actions/alberta-download.svg": 241741,
	"./actions/alberta-edit.svg": 701974,
	"./actions/alberta-fab-remove-duplicate.svg": 374186,
	"./actions/alberta-fab-resend.svg": 358883,
	"./actions/alberta-grouped-list.svg": 364563,
	"./actions/alberta-minus-clear.svg": 106872,
	"./actions/alberta-minus.svg": 537248,
	"./actions/alberta-numbered-list.svg": 981504,
	"./actions/alberta-patient-download.svg": 696087,
	"./actions/alberta-play.svg": 963872,
	"./actions/alberta-plus-clear.svg": 958861,
	"./actions/alberta-plus.svg": 702747,
	"./actions/alberta-preview.svg": 875564,
	"./actions/alberta-printer-outline.svg": 224411,
	"./actions/alberta-reorder.svg": 653273,
	"./actions/alberta-repeat.svg": 151139,
	"./actions/alberta-resend.svg": 50226,
	"./actions/alberta-reset.svg": 539216,
	"./actions/alberta-save-as-draft.svg": 941509,
	"./actions/alberta-save.svg": 981094,
	"./actions/alberta-scan.svg": 199283,
	"./actions/alberta-signature.svg": 918779,
	"./actions/alberta-stop-outline.svg": 491951,
	"./actions/alberta-stop.svg": 941363,
	"./actions/alberta-sync.svg": 941610,
	"./actions/alberta-trash.svg": 266566,
	"./actions/alberta-upload-new.svg": 463173,
	"./actions/alberta-upload.svg": 712847,
	"./activities/alberta-activities-sort-current.svg": 256614,
	"./activities/alberta-activities-sort-past.svg": 73420,
	"./activities/alberta-activities.svg": 962888,
	"./activities/alberta-activity-date.svg": 645097,
	"./activities/alberta-activity-endtime.svg": 471410,
	"./activities/alberta-activity-starttime.svg": 507494,
	"./activities/alberta-recurring-activity.svg": 209037,
	"./assets/alberta-add-appointment.svg": 678257,
	"./assets/alberta-additional-description.svg": 31506,
	"./assets/alberta-address.svg": 922361,
	"./assets/alberta-attachment.svg": 339732,
	"./assets/alberta-available.svg": 960826,
	"./assets/alberta-brush-outline.svg": 222033,
	"./assets/alberta-bug.svg": 565674,
	"./assets/alberta-call.svg": 106091,
	"./assets/alberta-camera.svg": 737215,
	"./assets/alberta-change-of-supplier.svg": 25446,
	"./assets/alberta-clipboard.svg": 877695,
	"./assets/alberta-clock.svg": 219611,
	"./assets/alberta-comment.svg": 172603,
	"./assets/alberta-content.svg": 742698,
	"./assets/alberta-customer-number.svg": 260564,
	"./assets/alberta-death.svg": 104989,
	"./assets/alberta-delayed.svg": 494201,
	"./assets/alberta-description.svg": 459203,
	"./assets/alberta-disk.svg": 374192,
	"./assets/alberta-document-excel-outline.svg": 193455,
	"./assets/alberta-document-info.svg": 367900,
	"./assets/alberta-document.svg": 59940,
	"./assets/alberta-dot-no.svg": 913847,
	"./assets/alberta-dot-unknown.svg": 374306,
	"./assets/alberta-dot-yes.svg": 467293,
	"./assets/alberta-dot.svg": 647727,
	"./assets/alberta-encrypted.svg": 863677,
	"./assets/alberta-erp.svg": 919360,
	"./assets/alberta-eye-off.svg": 456653,
	"./assets/alberta-eye.svg": 205554,
	"./assets/alberta-foto.svg": 434484,
	"./assets/alberta-gender.svg": 895083,
	"./assets/alberta-hammer-outline.svg": 266023,
	"./assets/alberta-hammer.svg": 887210,
	"./assets/alberta-healed.svg": 759953,
	"./assets/alberta-history.svg": 152903,
	"./assets/alberta-icon.svg": 311377,
	"./assets/alberta-info-circle.svg": 709221,
	"./assets/alberta-info-outline.svg": 658830,
	"./assets/alberta-info.svg": 723989,
	"./assets/alberta-invalid-section.svg": 153026,
	"./assets/alberta-iv-patient.svg": 51229,
	"./assets/alberta-key-solid.svg": 77753,
	"./assets/alberta-key.svg": 837244,
	"./assets/alberta-label-info.svg": 832288,
	"./assets/alberta-label-success.svg": 496542,
	"./assets/alberta-last-login.svg": 938297,
	"./assets/alberta-lens.svg": 235204,
	"./assets/alberta-lock.svg": 552159,
	"./assets/alberta-match.svg": 894734,
	"./assets/alberta-more.svg": 776240,
	"./assets/alberta-new.svg": 187455,
	"./assets/alberta-next-visit-delete.svg": 424506,
	"./assets/alberta-next-visit-field.svg": 822899,
	"./assets/alberta-nexttermin.svg": 85611,
	"./assets/alberta-not-available.svg": 996829,
	"./assets/alberta-note.svg": 298546,
	"./assets/alberta-notification-badge.svg": 657546,
	"./assets/alberta-operating-hours.svg": 280935,
	"./assets/alberta-outpatient.svg": 789359,
	"./assets/alberta-patient-inactive.svg": 215350,
	"./assets/alberta-person-chip.svg": 174854,
	"./assets/alberta-person.svg": 973660,
	"./assets/alberta-photo-gallery.svg": 642170,
	"./assets/alberta-picture.svg": 629169,
	"./assets/alberta-place.svg": 662895,
	"./assets/alberta-question.svg": 999232,
	"./assets/alberta-referrer.svg": 279553,
	"./assets/alberta-refresh.svg": 603931,
	"./assets/alberta-region.svg": 219411,
	"./assets/alberta-registration.svg": 570764,
	"./assets/alberta-report.svg": 133220,
	"./assets/alberta-reset-outline.svg": 288599,
	"./assets/alberta-return-arrow.svg": 634112,
	"./assets/alberta-return-delivery.svg": 700344,
	"./assets/alberta-ruler-outline.svg": 326180,
	"./assets/alberta-ruler.svg": 147109,
	"./assets/alberta-search-filled.svg": 195418,
	"./assets/alberta-sos.svg": 846929,
	"./assets/alberta-star.svg": 945949,
	"./assets/alberta-status-star.svg": 942963,
	"./assets/alberta-status.svg": 440319,
	"./assets/alberta-subunit.svg": 637720,
	"./assets/alberta-summary.svg": 141811,
	"./assets/alberta-team.svg": 393321,
	"./assets/alberta-text.svg": 189380,
	"./assets/alberta-unlock.svg": 869013,
	"./assets/alberta-warning.svg": 184692,
	"./assets/alberta-website-filled.svg": 443983,
	"./assets/alberta-website-light.svg": 121114,
	"./assets/alberta-website.svg": 237562,
	"./assets/alberta-zoom-in-outline.svg": 562994,
	"./assets/alberta-zoom-out-outline.svg": 449651,
	"./assets/itl-label-info.svg": 966182,
	"./chat/alberta-chat-assign.svg": 712024,
	"./chat/alberta-chat-channel-list-offline.svg": 820831,
	"./chat/alberta-chat-close.svg": 226869,
	"./chat/alberta-chat-selected-badge.svg": 564062,
	"./communication/alberta-address-book.svg": 752449,
	"./communication/alberta-fax.svg": 156582,
	"./communication/alberta-mail.svg": 739015,
	"./communication/alberta-message.svg": 834484,
	"./communication/alberta-mobile.svg": 322383,
	"./communication/alberta-notification.svg": 818126,
	"./communication/alberta-phone.svg": 694809,
	"./communication/alberta-support.svg": 86258,
	"./costestimate/alberta-costestimate.svg": 107027,
	"./fab-icons/alberta-fab-additional-order.svg": 384252,
	"./fab-icons/alberta-fab-box.svg": 272617,
	"./fab-icons/alberta-fab-change-document.svg": 889325,
	"./fab-icons/alberta-fab-checkbox-off.svg": 946595,
	"./fab-icons/alberta-fab-checkbox-on.svg": 110724,
	"./fab-icons/alberta-fab-contact-data.svg": 918207,
	"./fab-icons/alberta-fab-copy.svg": 253127,
	"./fab-icons/alberta-fab-costestimate.svg": 98870,
	"./fab-icons/alberta-fab-delete.svg": 227130,
	"./fab-icons/alberta-fab-document-outline.svg": 16487,
	"./fab-icons/alberta-fab-document.svg": 702004,
	"./fab-icons/alberta-fab-download.svg": 300890,
	"./fab-icons/alberta-fab-edit.svg": 915298,
	"./fab-icons/alberta-fab-fax.svg": 571783,
	"./fab-icons/alberta-fab-next-visit-delete.svg": 822874,
	"./fab-icons/alberta-fab-next-visit.svg": 216938,
	"./fab-icons/alberta-fab-order.svg": 775227,
	"./fab-icons/alberta-fab-patient-active.svg": 526041,
	"./fab-icons/alberta-fab-patient-inactive.svg": 528505,
	"./fab-icons/alberta-fab-pdf.svg": 815769,
	"./fab-icons/alberta-fab-print.svg": 909979,
	"./fab-icons/alberta-fab-return-delivery.svg": 643780,
	"./fab-icons/alberta-fab-send-email.svg": 395390,
	"./fab-icons/alberta-fab-send-full.svg": 288366,
	"./fab-icons/alberta-fab-send.svg": 51937,
	"./fab-icons/alberta-fab-service-order.svg": 799145,
	"./fab-icons/alberta-fab-share-native.svg": 756804,
	"./fab-icons/alberta-fab-share.svg": 447092,
	"./fab-icons/alberta-fab-status.svg": 566508,
	"./fab-icons/alberta-fab-stock-check.svg": 850579,
	"./fab-icons/alberta-fab-subunit.svg": 711355,
	"./inputs/alberta-checkbox-checked.svg": 215717,
	"./inputs/alberta-checkbox-empty.svg": 141565,
	"./institutions/alberta-crm.svg": 177895,
	"./institutions/alberta-doctor.svg": 230665,
	"./institutions/alberta-hospital.svg": 42699,
	"./institutions/alberta-nursinghome.svg": 408710,
	"./institutions/alberta-nursingservice.svg": 449705,
	"./institutions/alberta-payer.svg": 945430,
	"./institutions/alberta-pharmacy.svg": 488925,
	"./integratedcare/alberta-ic-attachments.svg": 204798,
	"./integratedcare/alberta-ic-edit.svg": 350479,
	"./integratedcare/alberta-ic-order.svg": 42490,
	"./integratedcare/alberta-ic-other.svg": 956059,
	"./integratedcare/alberta-ic-reminder.svg": 810967,
	"./integratedcare/alberta-ic-send.svg": 360198,
	"./medical/alberta-body-size.svg": 607127,
	"./medical/alberta-diagnosis.svg": 464476,
	"./medical/alberta-dialysis.svg": 888209,
	"./medical/alberta-human-body.svg": 947495,
	"./medical/alberta-weight.svg": 485690,
	"./medical/alberta-wound-bandage-change.svg": 958318,
	"./medical/alberta-wound-load.svg": 963120,
	"./medical/alberta-wound-location.svg": 232466,
	"./medical/alberta-wound-permanent.svg": 180840,
	"./menu/alberta-ai-assistant.svg": 479027,
	"./menu/alberta-burger-close.svg": 498096,
	"./menu/alberta-burger-menu-dashboard.svg": 81618,
	"./menu/alberta-burger-menu.svg": 60715,
	"./menu/alberta-calendar-check.svg": 217993,
	"./menu/alberta-calendar.svg": 247816,
	"./menu/alberta-chat.svg": 581500,
	"./menu/alberta-dashboard.svg": 586506,
	"./menu/alberta-help.svg": 938322,
	"./menu/alberta-lists.svg": 940388,
	"./menu/alberta-logout.svg": 889438,
	"./menu/alberta-portal.svg": 241504,
	"./menu/alberta-prescription-mgn.svg": 448568,
	"./menu/alberta-setting.svg": 8358,
	"./menu/alberta-swodoc.svg": 252884,
	"./navigation/alberta-arrow-down.svg": 722578,
	"./navigation/alberta-arrow-dropup.svg": 759083,
	"./navigation/alberta-arrow-left.svg": 122855,
	"./navigation/alberta-arrow-right.svg": 538824,
	"./navigation/alberta-fab-icon.svg": 395801,
	"./order/alberta-accounting-month.svg": 567034,
	"./order/alberta-across-therapy-order.svg": 967303,
	"./order/alberta-annotation.svg": 431583,
	"./order/alberta-contract.svg": 45925,
	"./order/alberta-direct-order-full.svg": 451413,
	"./order/alberta-direct-order.svg": 553501,
	"./order/alberta-euro.svg": 283179,
	"./order/alberta-interval.svg": 999302,
	"./order/alberta-lorry-return-delivery-in-details.svg": 600357,
	"./order/alberta-lorry-return-delivery.svg": 390654,
	"./order/alberta-lorry.svg": 45687,
	"./order/alberta-not-automatic-delivery.svg": 967826,
	"./order/alberta-pharmacy-only.svg": 442280,
	"./order/alberta-prescription-status.svg": 121531,
	"./order/alberta-private-sale-order.svg": 579236,
	"./order/alberta-product-group-checkmark.svg": 850218,
	"./order/alberta-seriesorder.svg": 175974,
	"./order/alberta-service-order.svg": 169597,
	"./order/alberta-shoppingcart-checkmark.svg": 227222,
	"./order/alberta-shoppingcart-euro.svg": 335320,
	"./order/alberta-shoppingcart-full-abo.svg": 721690,
	"./order/alberta-shoppingcart-full.svg": 727996,
	"./order/alberta-shoppingcart-small-icon-button.svg": 96962,
	"./order/alberta-shoppingcart-square-full.svg": 761847,
	"./order/alberta-shoppingcart-square.svg": 327103,
	"./order/alberta-shoppingcart.svg": 761504,
	"./patient/additional-address.svg": 293681,
	"./patient/alberta-additional-attributes.svg": 764205,
	"./patient/alberta-ambulant.svg": 29231,
	"./patient/alberta-birthday.svg": 666028,
	"./patient/alberta-contact-data.svg": 178200,
	"./patient/alberta-customer-id.svg": 348519,
	"./patient/alberta-fieldnurse.svg": 502697,
	"./patient/alberta-filter-active.svg": 393713,
	"./patient/alberta-filter-multiple.svg": 937793,
	"./patient/alberta-filter-nursinghome.svg": 833440,
	"./patient/alberta-filter.svg": 272338,
	"./patient/alberta-internal-data.svg": 805851,
	"./patient/alberta-person-cirle.svg": 159237,
	"./patient/alberta-pwr.svg": 738678,
	"./patient/alberta-search-clear.svg": 659666,
	"./patient/alberta-search.svg": 65979,
	"./patient/alberta-sort-1-to-9.svg": 345378,
	"./patient/alberta-sort-9-to-1.svg": 359417,
	"./patient/alberta-sort-a-to-z.svg": 190284,
	"./patient/alberta-sort-next-visit-current.svg": 999220,
	"./patient/alberta-sort-next-visit-future.svg": 665402,
	"./patient/alberta-sort-timestamp-new.svg": 509850,
	"./patient/alberta-sort-timestamp-old.svg": 795699,
	"./patient/alberta-sort-z-to-a.svg": 149297,
	"./patient/alberta-visit-days.svg": 648507,
	"./patient/alberta-visit-interval.svg": 983198,
	"./product/alberta-article.svg": 602203,
	"./product/alberta-contract-article-group.svg": 422442,
	"./product/alberta-maxamount.svg": 142660,
	"./product/alberta-packaging.svg": 80005,
	"./product/alberta-prescription.svg": 487407,
	"./product/alberta-produce.svg": 427709,
	"./product/alberta-productgroup.svg": 475777,
	"./product/alberta-productlist.svg": 639351,
	"./product/alberta-series-article.svg": 343957,
	"./product/alberta-service.svg": 865067,
	"./product/alberta-size.svg": 888125,
	"./product/alberta-stdcareproposal.svg": 795618,
	"./product/alberta-template.svg": 208027,
	"./product/alberta-vendor.svg": 578699,
	"./table/alberta-article-data.svg": 223339,
	"./table/alberta-circle.svg": 230272,
	"./table/alberta-false-cross-circle-icon.svg": 217765,
	"./table/alberta-individual-data.svg": 385010,
	"./table/alberta-insurance-price.svg": 99853,
	"./table/alberta-price.svg": 662651,
	"./table/alberta-true-check-circle-icon.svg": 30773,
	"./table/albertra-packaging-unit.svg": 768662,
	"./therapies/alberta-antibody-therapy.svg": 976503,
	"./therapies/alberta-asept.svg": 85460,
	"./therapies/alberta-breast-epithetics.svg": 211919,
	"./therapies/alberta-breath-therapy.svg": 723397,
	"./therapies/alberta-compression-therapy.svg": 180102,
	"./therapies/alberta-cross-therapy.svg": 674840,
	"./therapies/alberta-derive-incontinence.svg": 598517,
	"./therapies/alberta-diabetes.svg": 552835,
	"./therapies/alberta-diagnostics.svg": 862141,
	"./therapies/alberta-drug-distribution.svg": 446906,
	"./therapies/alberta-electrostimulation.svg": 593173,
	"./therapies/alberta-enteral-nutrition.svg": 987857,
	"./therapies/alberta-enterostomy.svg": 104765,
	"./therapies/alberta-general.svg": 286233,
	"./therapies/alberta-high-flow.svg": 338356,
	"./therapies/alberta-humidification.svg": 65560,
	"./therapies/alberta-imbibe-incontinence.svg": 12481,
	"./therapies/alberta-immunotherapy.svg": 428898,
	"./therapies/alberta-incontinence.svg": 792171,
	"./therapies/alberta-medical-engineering.svg": 594867,
	"./therapies/alberta-medical-technology.svg": 819405,
	"./therapies/alberta-monitoring.svg": 685953,
	"./therapies/alberta-orthopedic-technology.svg": 789665,
	"./therapies/alberta-pain-therapy.svg": 88381,
	"./therapies/alberta-parenteral-feeding.svg": 747,
	"./therapies/alberta-rehab-aids.svg": 369173,
	"./therapies/alberta-rehydration.svg": 609121,
	"./therapies/alberta-seat-shell-construction.svg": 38294,
	"./therapies/alberta-services.svg": 119089,
	"./therapies/alberta-sip-feeding.svg": 152912,
	"./therapies/alberta-storage-aids.svg": 469485,
	"./therapies/alberta-subcutane-infusion.svg": 549160,
	"./therapies/alberta-therapy-miscellaneous.svg": 119738,
	"./therapies/alberta-therapy.svg": 745307,
	"./therapies/alberta-tooth-splint.svg": 993701,
	"./therapies/alberta-tracheostomy.svg": 532899,
	"./therapies/alberta-wound.svg": 43410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875293;